import React, { useEffect, useRef, useState } from "react";
import { BsFillCaretDownFill, BsFillCaretUpFill } from "react-icons/bs";
import DownloadExcel from "../../../../Extra/DownloadExcel";
import axios from "axios";
import DynamicTable from "../../../../Extra/DynamicTable";

const SpeedWiseReport = ({ data, startDate, endDate }) => {
  const Header = {
    caution_id: "caution_id",
    station_from: "station_from",
    station_to: "station_to",
    date_from: "date_from",
    date_to: "date_to",
    speed_pass: "speed_pass",
    speed_goods: "speed_goods",
    reason: "reason",
    no_of_days_since_imposition: "no_of_days_since_imposition",
    department: "department",
    remarks: "remarks",
  };
  const urlPrefixBlock = process.env.REACT_APP_URL_BLOCK_PREFIX;

  const [sec, setSec] = useState("ANA-NKJ");
  const [secData, setSecData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  const key = [
    "Section",
    "null",
    "10",
    "15",
    "20",
    "30",
    "40",
    "50",
    "60",
    "70",
    "75",
    "80",
    "90",
    "95",
    "100",
    "105",
    "Other",
    "Grand Total",
  ];

  const fetchedData = async () => {
    setLoading(true);
    setError(false);
    try {
      const response = await axios.get(
        `${urlPrefixBlock}getAllCautionOrder?start=${startDate}&end=${endDate}&section=${sec}`,
      );
      if (response.data.status === "ok") {
        setSecData(response.data.data);
      } else {
        setSecData([]);
      }
    } catch (error) {
      console.error("Failed to fetch data:", error);
      setError(true);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchedData();
  }, [sec, startDate, endDate]);
  const table = useRef();
  const table1 = useRef();

  const sum = (column) => {
    return data.reduce((s, o) => s + Number(o[column] || 0), 0);
  };

  return (
    <div>
      {" "}
      <h6 className="p-3 bg-dark text-white">Speed Wise Caution Order</h6>
      <div className="table-responsive">
        <div>
          <table
            ref={table}
            className="table table-bordered table-striped text-center "
            style={{ fontSize: "13px" }}
          >
            <thead>
              <tr
                className="table-dark text-center align-middle"
                style={{ fontWeight: "bold" }}
              >
                <th> Sr No.</th>

                {key.map((Head, i) => (
                  <th
                    key={i}
                    style={{
                      whiteSpace: "normal",
                    }}
                  >
                    {Head.toUpperCase()}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {data &&
                data.map((o, i) => (
                  <tr
                    key={i}
                    onClick={() => setSec(o.section)}
                    className={sec === o.section ? "table-active" : ""}
                    style={{ cursor: "pointer" }}
                  >
                    <td> {i + 1}</td>
                    <td> {o["section"]}</td>
                    <td> {o["0"]}</td> <td> {o["10"]}</td> <td> {o["15"]}</td>{" "}
                    <td> {o["20"]}</td> <td> {o["30"]}</td> <td> {o["40"]}</td>{" "}
                    <td> {o["50"]}</td> <td> {o["60"]}</td>
                    <td> {o["70"]}</td> <td> {o["75"]}</td> <td> {o["80"]}</td>{" "}
                    <td> {o["90"]}</td> <td> {o["95"]}</td> <td> {o["100"]}</td>{" "}
                    <td> {o["105"]}</td>
                    <td> {o["Others"]}</td>
                    <td> {o["total_cautions"]}</td>
                  </tr>
                ))}
            </tbody>

            <tfoot>
              <tr className="table-dark fw-bold">
                <td colSpan={2}>Total</td>
                <td>{sum("0")}</td>
                <td>{sum("10")}</td>
                <td>{sum("15")}</td>
                <td>{sum("20")}</td>
                <td>{sum("30")}</td>
                <td>{sum("40")}</td>
                <td>{sum("50")}</td> <td>{sum("60")}</td>
                <td>{sum("70")}</td>
                <td>{sum("75")}</td>
                <td>{sum("80")}</td>
                <td>{sum("90")}</td>
                <td>{sum("95")}</td> <td>{sum("100")}</td>
                <td>{sum("105")}</td>
                <td>{sum("Others")}</td>
                <td>{sum("total_cautions")}</td>
              </tr>
            </tfoot>
          </table>{" "}
          <div className="mb-3">
            <DownloadExcel
              tableRef={table}
              fileName={`Long Duration Caution Summary ${startDate} - ${endDate}`}
            />
          </div>
        </div>
      </div>{" "}
      {/* <div
        className="row
      "
      >
        {secData && (
          <div>
            <div className="text-center bg-dark p-2 text-white ">
              <h5 className="text-center">
                {" "}
                Section Wise Caution Order Data
                <b style={{ color: "#b2b0b0ff" }}> ({sec})</b>
              </h5>
            </div>
            <div className="  bg-dark text-white pe-2 ps-2"> </div>
            <DynamicTable
              data={secData}
              headers={Header}
              rowsPerPage={10}
              fontSize={"12px"}
            />
          </div>
        )}
      </div> */}
    </div>
  );
};

export default SpeedWiseReport;
